import { mixed, object, setLocale, string } from 'yup'
import { Id } from 'src/types'

setLocale({
  mixed: {
    default: 'common.required',
    notType: 'common.required',
    required: 'common.required'
  }
})

export const validationTenantSchema = object().shape({
  tenant_id: mixed().required(),
  tenant_organization_name: string().when('tenant_id', {
    is: (tenant_id: Id) => typeof tenant_id === 'string',
    then: string().notRequired(),
    otherwise: string().required()
  }),
  tenant_sufix: string().when('tenant_id', {
    is: (tenant_id: Id) => typeof tenant_id === 'string',
    then: string().required(),
    otherwise: string().notRequired()
  })
})

export const validationDrawerSchema = object().shape({
  address_number: string().notRequired(),
  address: string().notRequired(),
  city_id: string().required(),
  code: string().notRequired(),
  country_id: string().required(),
  description: string().notRequired(),
  email: string().required(),
  legal_name: string().required(),
  organization_id: string().required(),
  organization_type: string().required(),
  phone_contact: string().notRequired(),
  state_id: string().required(),
  trade_name: string().required(),
  user_limit: string().required(),
  vat_number: string().required()
})
